import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import ScrollView from "vue-scrollview";
// default options
const options = {
	throttle: 50,
	callbacks: [],
};
Vue.use(ScrollView, options);

import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
Vue.component("v-icon", Icon);

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

const firebaseConfig = {
	apiKey: "AIzaSyA9gMfvyJUuUYgiQezYrVhiTkt_fcxZsu8",
	authDomain: "alduin-app.firebaseapp.com",
	databaseURL: "https://alduin-app.firebaseio.com",
	projectId: "alduin-app",
	storageBucket: "alduin-app.appspot.com",
	messagingSenderId: "16091101621",
	appId: "1:16091101621:web:bde6d473f49ff0d2a601fc",
};

if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);

var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

import Clipboard from "v-clipboard";
Vue.use(Clipboard);

Vue.prototype.$db = firebase.firestore();
Vue.prototype.$songs = firebase.firestore().collection("songs");
Vue.prototype.$auth = firebase.auth();
Vue.prototype.$functions = firebase.functions();
const user = firebase.auth().currentUser;
Vue.prototype.$user = user;
Vue.prototype.$regex = /[.,/#!$%^&{}*;:=\-_`~()?"]/g;

firebase.auth().onAuthStateChanged(() => {
	new Vue({
		router,
		store,
		render: (h) => h(App),
	}).$mount("#app");
});
